const isResponseJson = (response: Response): boolean =>
  (response.headers.get("Content-Type") || "").indexOf("application/json") !==
  -1

export type ErrorField = {
  key: string
  name: string
  message: string
  [key: string]: any
}

export type ErrorsMap = {
  [key: string]: string
}

export type ErrorFields = Array<ErrorField>

export class ApiError extends Error {
  fields: ErrorFields | null
  errorsMap?: ErrorsMap
  info?: any
  json?: any
  constructor(
    message: string,
    fields?: ErrorFields | null,
    info?: any,
    json?: any,
  ) {
    super(message)
    this.name = this.constructor.name
    this.info = info
    this.fields = fields || null
    this.json = json
    if (fields && fields.length) {
      this.errorsMap = fields.reduce((all, next) => {
        all[next.name] = next.key
        return all
      }, {} as ErrorsMap)
    }
  }
}

export const parseApiError = async (response: Response): Promise<ApiError> => {
  const J = isResponseJson(response)
  if (J) {
    const jsonError = await response.json()
    const error = jsonError || {}
    const message =
      error?.error?.key ||
      error.key ||
      error.message ||
      error?.error?.message ||
      error.error ||
      error.name ||
      error.description ||
      "The action could not be completed due to errors"

    const fields = error.fields ?? null
    const info = error.info
    return new ApiError(
      message,
      fields,
      { ...info, status: response.status },
      jsonError,
    )
  } else {
    let message = await response.text()
    return new ApiError(message, undefined, { status: response.status })
  }
}
